import { SurveyAnswersState } from "@utils/redux/slices/surveyAnswers";
import getStore from "../redux/store";
import { genderConstants, sexConstants } from "../sexAndGender";
import { UnitName } from "../Unit";
import { addMonitoringEventHandler } from "./bus";

/**
 * Fullstory property names are required to have a type suffix, with a few exceptions:
 * https://help.fullstory.com/hc/en-us/articles/360020623234#property-name-requirements
 */
export enum FullstoryUserProperties {
  ageRange = "ageRange_str",
  email = "email",
  employmentLifestyle = "employmentLifestyle_str",
  gender = "gender_str",
  sex = "sex_str",
  // Suffix added to the key to not get wires crossed with the weightLossGoal question ID.
  weightLossGoal_int = "weightLossGoal_int",
  weightLossUnit = "weightLossUnit_str",
}

addMonitoringEventHandler((event) => {
  if (event.type === "track") {
    if (event.eventName === "$experiment_started") {
      (window as any).FS.event("Experiment Started", {
        experimentName_str: event.properties["Experiment name"],
        variantName_str: event.properties["Variant name"],
      });
    }
  }
  // Only update FS here if the buyflow event is not also being sent to mixpanel
  // directly, to prevent duplicate logging.
  if (event.type === "buyflowEvent" && !event.extras?.blockRoutingToMixpanel) {
    if (event.eventName === "ExperimentStarted") {
      (window as any).FS.event("Experiment Started", {
        experimentName_str: event.properties["Experiment name"],
        variantName_str: event.properties["Variant name"],
      });
    } else if (event.eventName === "BuyflowQuestionAnswered") {
      const answers: SurveyAnswersState = event.properties;
      Object.keys(answers).forEach((key) => {
        if (key in FullstoryUserProperties) {
          updateFullstoryUser({
            [FullstoryUserProperties[key]]: answers[key][0],
          });
        }
      });
    }
  }
});

export function identifyFullstoryUser(
  userData = getStore().getState().userData
) {
  const { user_id } = userData;

  (window as any).FS.identify(user_id);
}

type UserProperties = {
  [FullstoryUserProperties.ageRange]?: SurveyAnswersState["ageRange"][0];
  [FullstoryUserProperties.email]?: string;
  [FullstoryUserProperties.employmentLifestyle]?: SurveyAnswersState["employmentLifestyle"][0];
  [FullstoryUserProperties.gender]?: genderConstants;
  [FullstoryUserProperties.sex]?: sexConstants;
  [FullstoryUserProperties.weightLossGoal_int]?: number;
  [FullstoryUserProperties.weightLossUnit]?: UnitName;
};

export function updateFullstoryUser(properties: UserProperties) {
  (window as any).FS.setUserVars(properties);
}
